import ApiService from "@/core/services/ApiService";

class AuthService {

    //logIn
    public static logIn(data: any) {
        return ApiService.post('public/login', data)
    }

    //recuperar contraseña
    public static forgotPassword(data: any) {
        return ApiService.post('public/forgot-password', data)
    }

    //verifi hash for reset password
    public static checkHashResetPassword(code: any){
        return ApiService.get('public/check-hash-password', code)
    }

    //set new password
    public static changePassword(data: any){
        return ApiService.post('public/reset-password', data)
    }

}

export default AuthService